import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './chart.types';

const baseSelectors = generateResourceSelectors<types.IChart>((state) => state.resource.chart);

export const chartSelectors = {
  ...baseSelectors,
  selectDraftChart: (state: Parameters<typeof baseSelectors.selectResourceList>[0]): types.IChart | null =>
    baseSelectors.selectResourceList(state).find((chart) => chart.status === 'draft') ?? null,
};
